import React from "react";

function AddTagIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 37.224 31.028" className={className}>
      <g fill="none" stroke="#b9b9b9" strokeWidth="2" strokeDasharray="5">
        <circle cx="15.514" cy="15.514" r="15.514" stroke="none" />
        <circle cx="15.514" cy="15.514" r="14.514" fill="none" />
      </g>
      <path
        d="M17.343,10.036,14.86,7.555a1.761,1.761,0,0,0-1.246-.514H11.433a.879.879,0,0,0-.88.88V10.1a1.754,1.754,0,0,0,.514,1.243l2.483,2.481a.881.881,0,0,0,1.246,0l2.544-2.544a.876.876,0,0,0,0-1.243Zm-5.027-.578a.66.66,0,1,1,.66-.66.658.658,0,0,1-.66.66ZM6.161,7.038A3.519,3.519,0,1,0,2.64,3.52,3.52,3.52,0,0,0,6.161,7.038ZM9.675,10.1V8.086a3.7,3.7,0,0,0-1.051-.171H8.166a4.788,4.788,0,0,1-4.01,0H3.7a3.7,3.7,0,0,0-3.7,3.7v1.144a1.32,1.32,0,0,0,1.32,1.32H11a1.314,1.314,0,0,0,1.042-.52l-1.6-1.6A2.623,2.623,0,0,1,9.675,10.1Z"
        transform="translate(7 8)"
        fill="#b9b9b9"
      />
      <path
        d="M5.957,0A5.957,5.957,0,1,1,0,5.957,5.957,5.957,0,0,1,5.957,0Z"
        transform="translate(25.311 10.285)"
        fill="#232f34"
      />
      <text
        transform="translate(27.975 19.119)"
        fill="#fff"
        fontSize="11"
        fontFamily="Quicksand-Medium, Quicksand"
        fontWeight="500"
        letterSpacing="-0.024em"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
    </svg>
  );
}

export { AddTagIcon };
